import { render, staticRenderFns } from "./ossConfigDialog.vue?vue&type=template&id=569094fc&scoped=true"
import script from "./ossConfigDialog.vue?vue&type=script&lang=js"
export * from "./ossConfigDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569094fc",
  null
  
)

export default component.exports